import { render } from "./DeliveryTooltip.vue?vue&type=template&id=f1f9b5e6&scoped=true"
const script = {}

import "./DeliveryTooltip.vue?vue&type=style&index=0&id=f1f9b5e6&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1f9b5e6"],['__file',"webpack-assets/vue/templates/product/catalog/parts/DeliveryTooltip.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f1f9b5e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f1f9b5e6', __exports__)) {
    api.reload('f1f9b5e6', __exports__)
  }
  
  module.hot.accept("./DeliveryTooltip.vue?vue&type=template&id=f1f9b5e6&scoped=true", () => {
    api.rerender('f1f9b5e6', render)
  })

}


export default __exports__